import styled from "@emotion/styled";
import { fontPlayfairDisplay, setLineClamp } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";
import { EntityLink } from "~/components/entity-link";
import { setFullViewportWidthStyles } from "~/lib/styles";

export const StyledBaseImage = styled(BaseImage)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  align-items: center;

  ${props => props.theme.breakpoints.up("tablet")} {
    row-gap: 64px;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;

  inline-size: 100%;

  ${props => props.theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 20px;
  }
`;

export const Item = styled.div`
  inline-size: 100%;
  block-size: 100%;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 220px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 300px;
  }
  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    inline-size: 378px;
  }
  ${props => props.theme.breakpoints.up("largeDesktop")} {
    inline-size: 400px;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  display: block;

  color: inherit;
`;

export const StyledFigure = styled.figure`
  aspect-ratio: 1;

  ${props => props.theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()};
  }
`;

export const Headline = styled.div`
  margin-block-start: 20px;

  color: #000000;
  font-size: 20px;
  font-family: ${fontPlayfairDisplay};

  ${setLineClamp(4, "26px")}

  ${props => props.theme.breakpoints.up("mediumDesktop")} {
    ${setLineClamp(3, "30px")}
    font-size: 24px;
  }
`;

export const Title = styled.div`
  color: #222222;
  font-size: 32px;
  font-family: ${fontPlayfairDisplay};
  line-height: 32px;
  letter-spacing: -1.28px;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 48px;
    line-height: 48px;
    letter-spacing: -1.44px;
  }

  span {
    font-style: italic;
  }
`;
